import React from 'react'
import './Header.css'

const Header = ({ title, subtitle, className = '', ...props }) => {
  const classes = [
    'header',
    className
  ].filter(Boolean).join(' ')

  return (
    <header className={classes} {...props}>
      <div className="header-content">
        {title && <h1 className="header-title">{title}</h1>}
        {subtitle && <p className="header-subtitle">{subtitle}</p>}
      </div>
    </header>
  )
}

export default Header
